import { useV2Router, type LensId } from '../router'

const MOBILE_LENS_ORDER: LensId[] = [
  'home', 'reflect', 'explore', 'finance', 'health', 'mind', 'collaborate',
]

const ICONS: Record<LensId, string> = {
  home: '🏠', reflect: '🪞', explore: '🔍', judgment: '⚖️',
  finance: '💰', health: '❤️', mind: '🧠',
  collaborate: '🤝', graph: '🕸',
}

const LABELS: Record<LensId, string> = {
  home: 'Home', reflect: 'Reflect', explore: 'Explore', judgment: 'Judge',
  finance: 'Finance', health: 'Health', mind: 'Mind',
  collaborate: 'Collab', graph: 'Graph',
}

export function BottomNav() {
  const { lens, navigate } = useV2Router()

  return (
    <nav
      aria-label="Lens navigation"
      className="flex items-stretch justify-around border-t border-border-subtle bg-bg-surface"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 4px)' }}
    >
      {MOBILE_LENS_ORDER.map((id) => {
        const active = lens === id
        return (
          <button
            key={id}
            type="button"
            onClick={() => navigate(id)}
            aria-label={LABELS[id]}
            aria-current={active ? 'page' : undefined}
            className={`flex flex-col items-center justify-center gap-0.5 flex-1 min-h-[52px] py-1 transition ${
              active ? 'text-accent-primary' : 'text-text-subtle active:text-text-base'
            }`}
          >
            <span className="text-xl leading-none" aria-hidden="true">{ICONS[id]}</span>
            <span className="text-[9px] leading-tight truncate max-w-full px-0.5">{LABELS[id]}</span>
          </button>
        )
      })}
    </nav>
  )
}
